import React from "react";
import {
  Modal,
  Button,
  Table,
  Badge 
} from "react-bootstrap";
import  './index.css'
const ShowAdminBankWebsitePermission = ({  show ,  handleClose , data , callingFor}) => {

    const renderStatus = (value) => {
    return value ? (
      <Badge className="custom-badge">Yes</Badge>
    ) : (
      <Badge bg="secondary">No</Badge>
    );
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Body>
          <div className="table-responsive" style={{maxHeight : '400px'}}>
            <Table striped bordered hover className="mb-0">
              <thead className="table">
                <tr>
                  {callingFor === 'bank' ? <th>Bank Name</th> : <th>Website Name</th>}      
                  <th>View</th>
                  <th>Deposit</th>
                  <th>Withdraw</th>
                  <th>Edit</th>
                  <th>Renew</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((bank, index) => (
                    <tr key={index}>
                      {callingFor === 'bank' ? <td>{bank.bankName}</td> : <td>{bank.websiteName}</td>}
                      <td>{renderStatus(bank.isView)}</td>
                      <td>{renderStatus(bank.isDeposit)}</td>
                      <td>{renderStatus(bank.isWithdraw)}</td>
                      <td>{renderStatus(bank.isEdit)}</td>
                      <td>{renderStatus(bank.isRenew)}</td>
                      <td>{renderStatus(bank.isDelete)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center' }}>No Data Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default React.memo(ShowAdminBankWebsitePermission);

